import { action } from 'typesafe-actions';
import { StudentActionTypes } from './types';
import {
  EducationSponsorship,
  FamilySponsorship,
  IAccommodationStatus,
  IDocuments,
  IFinanceDocuments,
  ISummary,
  ITravelStatus,
  IVisa,
  IVisaStatus,
  OrganisationSponsorship,
  OtherSponsorship,
  ScholarshipSponsorship,
  IExceedRecordedInterview
} from '../../types';
import { IMessage, IOffer } from 'types';
import { IRecordedInterviewBody } from '../../api/api';
import { toast } from 'react-toastify';

export const savePersonalInfo = (source: string, config: any) =>
  action(StudentActionTypes.SAVE_PERSONAL_INFO, { source, config });
export const savePersonalInfoSuccess = (cas: IVisa) => action(StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS, cas);
export const savePersonalInfoFailure = (error: string) => action(StudentActionTypes.SAVE_PERSONAL_INFO_FAILURE, error);

export const saveHistory = (source: string, config: any) => action(StudentActionTypes.SAVE_HISTORY, { source, config });
export const saveHistorySuccess = (cas: IVisa) => action(StudentActionTypes.SAVE_HISTORY_SUCCESS, cas);
export const saveHistoryFailure = (error: string) => action(StudentActionTypes.SAVE_HISTORY_FAILURE, error);

export const saveConsents = (source: string, config: any) =>
  action(StudentActionTypes.SAVE_CONSENTS, { source, config });
export const saveConsentsSuccess = (cas: IVisa) => action(StudentActionTypes.SAVE_CONSENTS_SUCCESS, cas);
export const saveConsentsFailure = (error: string) => action(StudentActionTypes.SAVE_CONSENTS_FAILURE, error);

export const saveDocuments = (sponsorType: string, sponsorKey: string, docType: string | null, docKey: string | null) =>
  action(StudentActionTypes.SAVE_DOCUMENTS, {
    sponsorType,
    sponsorKey,
    docType,
    docKey
  });
export const saveDocumentsSuccess = (documents: IDocuments) =>
  action(StudentActionTypes.SAVE_DOCUMENTS_SUCCESS, documents);
export const saveDocumentsFailure = (error: string) => action(StudentActionTypes.SAVE_DOCUMENTS_FAILURE, error);

export const saveFinanceDocuments = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null
) =>
  action(StudentActionTypes.SAVE_FINANCE_DOCUMENTS, {
    sponsorType,
    sponsorKey,
    docType,
    docKey
  });
export const saveFinanceDocumentsSuccess = (financeDocuments: IFinanceDocuments) =>
  action(StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS, financeDocuments);
export const saveFinanceDocumentsFailure = (error: string) =>
  action(StudentActionTypes.SAVE_FINANCE_DOCUMENTS_FAILURE, error);

export const saveFollowUpDocuments = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null
) =>
  action(StudentActionTypes.SAVE_FOLLOW_UP_DOCUMENTS, {
    sponsorType,
    sponsorKey,
    docType,
    docKey
  });

export const saveFollowUpDocumentsBRPWillNotReceiving = (docKey: string, reason: string) =>
  action(StudentActionTypes.SAVE_FOLLOW_UP_DOCUMENTS_BRP_WILL_NOT_RECEIVING, {
    reason,
    docKey
  });

export const saveFollowUpDocumentsShareCode = (docKey: string, data: any) =>
  action(StudentActionTypes.SAVE_FOLLOW_UP_DOCUMENTS_SHARE_CODE, {
    data,
    docKey
  });

export const saveFollowUpDocumentsSuccess = (financeDocuments: IFinanceDocuments) =>
  action(StudentActionTypes.SAVE_FOLLOW_UP_DOCUMENTS_SUCCESS, financeDocuments);
export const saveFollowUpDocumentsFailure = (error: string) =>
  action(StudentActionTypes.SAVE_FOLLOW_UP_DOCUMENTS_FAILURE, error);

export const getStudentRecord = (intakeId: string, offerId: string) =>
  action(StudentActionTypes.GET_STUDENT_RECORD, {
    intakeId,
    offerId
  });
export const getStudentRecordSuccess = (student: IVisa, config: any, uniConfig: any) =>
  action(StudentActionTypes.GET_STUDENT_RECORD_SUCCESS, {
    student,
    config,
    uniConfig
  });
export const getStudentRecordFailure = (error: string) => action(StudentActionTypes.GET_STUDENT_RECORD_FAILURE, error);
export const getStudentDocs = () => action(StudentActionTypes.GET_STUDENT_DOCS);
export const getStudentDocsSuccess = (documents: IDocuments) =>
  action(StudentActionTypes.GET_STUDENT_DOCS_SUCCESS, {
    documents
  });
export const getStudentFinDocs = () => action(StudentActionTypes.GET_STUDENT_FIN_DOCS);
export const getStudentFinDocsSuccess = (financeDocuments: IDocuments) =>
  action(StudentActionTypes.GET_STUDENT_FIN_DOCS_SUCCESS, {
    financeDocuments
  });
export const getStudentFollowUpDocs = () => action(StudentActionTypes.GET_STUDENT_FOLLOW_UP_DOCS);
export const getStudentFollowUpDocsSuccess = (followUpDocuments: IDocuments) =>
  action(StudentActionTypes.GET_STUDENT_FOLLOW_UP_DOCS_SUCCESS, {
    followUpDocuments
  });

export const getStudentMessages = () => {
  return action(StudentActionTypes.GET_STUDENT_MESSAGES);
};
export const getStudentMessagesSuccess = (messages: any) => {
  return action(StudentActionTypes.GET_STUDENT_MESSAGES_SUCCESS, {
    messages
  });
};

export const saveFinanceInfoSuccess = (res: IVisa) => action(StudentActionTypes.SAVE_FINANCE_SUCCESS, res);
export const saveFinanceInfoFailure = (error: string) => action(StudentActionTypes.SAVE_FINANCE_FAILURE, error);

export const saveDeposit = () => action(StudentActionTypes.SAVE_DEPOSIT);

export const saveHasViewedBypassWelcomeMessage = () => action(StudentActionTypes.SAVE_VIEWED_BYPASS_WELCOME_MESSAGE);
export const saveHasViewedBypassWelcomeMessageSuccess = () =>
  action(StudentActionTypes.SAVE_VIEWED_BYPASS_WELCOME_MESSAGE_SUCCESS);
export const saveHasViewedBypassWelcomeMessageFailure = (error: string) =>
  action(StudentActionTypes.SAVE_VIEWED_BYPASS_WELCOME_MESSAGE_FAILURE, error);

export const createOrganisationSponsor = (data: OrganisationSponsorship) =>
  action(StudentActionTypes.CREATE_ORGANISATION_SPONSOR, {
    data
  });
export const updateOrganisationSponsor = (key: string, data: OrganisationSponsorship) =>
  action(StudentActionTypes.UPDATE_ORGANISATION_SPONSOR, {
    key,
    data
  });
export const removeOrganisationSponsor = (key: string) =>
  action(StudentActionTypes.REMOVE_ORGANISATION_SPONSOR, {
    key
  });
export const removeOrganisationRegion = () => action(StudentActionTypes.REMOVE_ORGANISATION_REGION);

export const createScholarshipSponsor = (data: ScholarshipSponsorship) =>
  action(StudentActionTypes.CREATE_SCHOLARSHIP_SPONSOR, {
    data
  });
export const updateScholarshipSponsor = (key: string, data: ScholarshipSponsorship) =>
  action(StudentActionTypes.UPDATE_SCHOLARSHIP_SPONSOR, {
    key,
    data
  });
export const bulkUpdateScholarshipSponsor = (data: { key: string; data: ScholarshipSponsorship }[]) =>
  action(StudentActionTypes.BULK_UPDATE_SCHOLARSHIP_SPONSOR, {
    data
  });
export const removeScholarshipSponsor = (key: string) =>
  action(StudentActionTypes.REMOVE_SCHOLARSHIP_SPONSOR, {
    key
  });
export const removeScholarshipRegion = () => action(StudentActionTypes.REMOVE_SCHOLARSHIP_REGION);

export const createEducationSponsor = (data: EducationSponsorship) =>
  action(StudentActionTypes.CREATE_EDUCATION_SPONSOR, {
    data
  });
export const updateEducationSponsor = (key: string, data: EducationSponsorship) =>
  action(StudentActionTypes.UPDATE_EDUCATION_SPONSOR, {
    key,
    data
  });
export const removeEducationSponsor = (key: string) =>
  action(StudentActionTypes.REMOVE_EDUCATION_SPONSOR, {
    key
  });
export const removeEducationRegion = () => action(StudentActionTypes.REMOVE_EDUCATION_REGION);

export const createFamilySponsor = (data: FamilySponsorship) =>
  action(StudentActionTypes.CREATE_FAMILY_SPONSOR, {
    data
  });
export const updateFamilySponsor = (key: string, data: FamilySponsorship) =>
  action(StudentActionTypes.UPDATE_FAMILY_SPONSOR, {
    key,
    data
  });
export const removeFamilySponsor = (key: string) =>
  action(StudentActionTypes.REMOVE_FAMILY_SPONSOR, {
    key
  });
export const removeFamilyRegion = () => action(StudentActionTypes.REMOVE_FAMILY_REGION);

export const createOtherSponsor = (data: OtherSponsorship) =>
  action(StudentActionTypes.CREATE_OTHER_SPONSOR, {
    data
  });
export const updateOtherSponsor = (key: string, data: OtherSponsorship) =>
  action(StudentActionTypes.UPDATE_OTHER_SPONSOR, {
    key,
    data
  });
export const removeOtherSponsor = (key: string) =>
  action(StudentActionTypes.REMOVE_OTHER_SPONSOR, {
    key
  });
export const removeOtherRegion = () => action(StudentActionTypes.REMOVE_OTHER_REGION);

export const savePreCasInterview = (source: string) => action(StudentActionTypes.SAVE_PRE_CAS_INTERVIEW, source);
export const savePreCasInterviewSuccess = (cas: IVisa) =>
  action(StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS, cas);
export const savePreCasInterviewFailure = (error: string) =>
  action(StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_FAILURE, error);

export const saveTravelStatus = (data: ITravelStatus) => action(StudentActionTypes.SAVE_TRAVEL_STATUS, data);
export const saveTravelStatusSuccess = (student: IVisa) =>
  action(StudentActionTypes.SAVE_TRAVEL_STATUS_SUCCESS, student);
export const saveTravelStatusFailure = (error: string) => action(StudentActionTypes.SAVE_TRAVEL_STATUS_FAILURE, error);

export const saveVisaStatus = (data: { status: IVisaStatus }) => action(StudentActionTypes.SAVE_VISA_STATUS, data);
export const saveVisaStatusSuccess = (student: IVisa) => action(StudentActionTypes.SAVE_VISA_STATUS_SUCCESS, student);
export const saveVisaStatusFailure = (error: string) => action(StudentActionTypes.SAVE_VISA_STATUS_FAILURE, error);

export const saveRecordedInterviewAttempt = (data: IRecordedInterviewBody) =>
  action(StudentActionTypes.SAVE_RECORDED_INTERVIEW_ATTEMPT, data);
export const recordedInterviewIsWidgetOpened = ({ isWidgetOpened, key }: { isWidgetOpened: boolean; key: string }) =>
  action(StudentActionTypes.RECORDED_INTERVIEW_IS_WIDGET_OPENED, { isWidgetOpened, key });
export const saveRecordedInterviewAttemptSuccess = (student: IVisa) =>
  action(StudentActionTypes.SAVE_RECORDED_INTERVIEW_ATTEMPT_SUCCESS, student);
export const saveRecordedInterviewAttemptFailure = (error: string) => {
  toast.error(`There was an error storing interview. Please try again!`);
  return action(StudentActionTypes.SAVE_RECORDED_INTERVIEW_ATTEMPT_FAILURE, error);
};

export const saveAccommodationStatus = (data: IAccommodationStatus) =>
  action(StudentActionTypes.SAVE_ACCOMMODATION_STATUS, data);
export const saveAccommodationStatusSuccess = (student: IVisa) =>
  action(StudentActionTypes.SAVE_ACCOMMODATION_STATUS_SUCCESS, student);
export const saveAccommodationStatusFailure = (error: string) =>
  action(StudentActionTypes.SAVE_ACCOMMODATION_STATUS_FAILURE, error);

export const saveVisaPrepForm = (source: string) => action(StudentActionTypes.SAVE_VISA_PREP_FORM, source);
export const saveVisaPrepFormSuccess = (cas: IVisa) => action(StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS, cas);
export const saveVisaPrepFormFailure = (error: string) => action(StudentActionTypes.SAVE_VISA_PREP_FORM_FAILURE, error);

export const saveMessage = (message: IMessage) => action(StudentActionTypes.SAVE_MESSAGE, message);
export const saveMessageSuccess = (message: IMessage) => action(StudentActionTypes.SAVE_MESSAGE_SUCCESS, message);
export const saveMessageFailure = (message: IMessage) => action(StudentActionTypes.SAVE_MESSAGE_FAILURE, message);
export const newMessage = (message: IMessage) => action(StudentActionTypes.NEW_MESSAGE, message);

export const markMessagesRead = (messageIds: Array<string>) =>
  action(StudentActionTypes.MARK_MESSAGES_READ, messageIds);
export const markMessagesReadSuccess = (messageIds: Array<string>) =>
  action(StudentActionTypes.MARK_MESSAGES_READ_SUCCESS, { messageIds });
export const markMessagesReadFailure = (error: string) => action(StudentActionTypes.MARK_MESSAGES_READ_FAILURE, error);

export const uploadFile = (docTitle: string, docType: string, index: number, fileName: string, file: any) =>
  action(StudentActionTypes.FILE_UPLOAD, {
    docTitle: docTitle,
    docType: docType,
    index: index,
    fileName: fileName,
    file: file
  });

export const confirmUploads = (docType: string, index: number | string, fileNames: string[]) =>
  action(StudentActionTypes.CONFIRM_UPLOAD, {
    docType: docType,
    fileNames: fileNames,
    index: index
  });
export const confirmFinanceUploads = (id: string, docType: string, index: number | string, fileNames: string[]) =>
  action(StudentActionTypes.CONFIRM_FINANCE_UPLOAD, {
    id,
    docType: docType,
    fileNames: fileNames,
    index: index
  });
export const unsubscribe = (email: string, studentID: string) =>
  action(StudentActionTypes.UNSUBSCRIBE, { email, studentID });
export const unsubscribeSuccess = () => action(StudentActionTypes.UNSUBSCRIBE_SUCCESS);

export const updateSummary = (summary: Partial<ISummary>) => action(StudentActionTypes.UPDATE_SUMMARY, { ...summary });
export const updateCalendlyInterviewWS = (payload: Partial<IOffer>) =>
  action(StudentActionTypes.UPDATE_CALENDLY_INTERVIEW_WS, payload);

export const handleWebsocketStudentRecords = (data: any) =>
  action(StudentActionTypes.STUDENT_WEBSOCKET_CHANGE, { data });

export const exceededStudentRecordedInterview = (payload: IExceedRecordedInterview) => {
  toast.error('This interview is no longer available', {
    autoClose: 5000
  });
  return action(StudentActionTypes.EXCEED_RECORDED_INTERVIEW, payload);
};
export const exceededStudentRecordedInterviewSuccess = interviews =>
  action(StudentActionTypes.EXCEED_RECORDED_INTERVIEW_SUCCESS, interviews);
export const exceededStudentRecordedInterviewFailure = (message: string) =>
  action(StudentActionTypes.EXCEED_RECORDED_INTERVIEW_FAILURE, message);

export const getStudentRecordedInterviews = () => {
  return action(StudentActionTypes.GET_STUDENT_RECORDED_INTERVIEWS);
};
export const getStudentRecordedInterviewsSuccess = (recordedInterviews: any) => {
  return action(StudentActionTypes.GET_STUDENT_RECORDED_INTERVIEWS_SUCCESS, {
    recordedInterviews
  });
};
